export const CONSENT = 'Consent';
export const PAGE_VISIT = 'Seitenaufruf';
export const FAQ_FEEDBACK = 'FAQ Feedback';
export const REGISTRATION_STEP = 'Registrierungs-Schritt';
export const REGISTRATION = 'Registrierung';
export const CHARACTERISTIC_SELECTION = 'Tag-Auswahl';
export const TAG_SEARCH = 'Tag-Suche';
export const QUESTIONNAIRE = 'Fragebogen';
export const APPLICANT_JOB = 'Jobwunsch';
export const APPLICANT_VITA = 'Lebenslauf';
export const FAVORITE = 'Favoriten';
export const NOTICE = 'Notiz';
export const EXCLUSION = 'Ausschluss';

export function push (eventData)
{
	if (typeof _paq === 'undefined')
	{
		return;
	}

	_paq.push(['trackEvent', eventData.getEvent(), eventData.getAction(), eventData.getName()]);
}
